<template>
  <div v-if="text">
    <span class="bus--seat--tooltip">{{ text }}</span>
    <span class="bus--seat--dot" />
  </div>
</template>

<script>
export default {

  name: 'SeatTooltip',

  props: ['seat'],

  computed: {
    passengers () {
      return this.$store.state.reservation.passengers
    },
    text () {
      return (index => {
        return index != -1 ? this.passengers[index].name || this.passengers[index].surname ? [this.passengers[index].name, this.passengers[index].surname].join(' ') : 'PASAJERO ' + (index + 1) : null
      })(this.passengers.findIndex(p => p.seat_id == this.seat.id))
    }
    // pax(){
    // 	return this.passengers.find(p => p.seat_id == this.seat.id)
    // }
  }
}
</script>

<style lang="css" scoped>
</style>
